export const SameLang = 
{ label: "同じ言語", value: "Same language" }

export const s3_dir = process.env.REACT_APP_S3_FILE_DIR || "/"